export default __webpack_public_path__ + "a0e477f2f1f9d2376fde931ee7c6241a.woff2";